import { FormControl, Validators, ValidatorFn } from '@angular/forms';
import { cellPhoneCountryValidator } from './cell-phone-country.shared.validator';
import { ILoyaltyAppCountryAssignmentModel } from '@shared/state';

export const cellPhoneValidator = (control: FormControl): OLO.Common.IValidators => {
    if (!control.value) {
        return null;
    }
    // valid formats:
    // (123) 456-7890
    // (123)456-7890
    // 123-456-7890
    // 123.456.7890
    // 1234567890
    // +31636363634
    // 075-63546725
    // const REGEX = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

    const REGEX = /^[0-9]*$/im;

    return REGEX.test(control.value) ? null : { cellPhoneError: { message: 'Invalid cell phone format', value: null } };
};

export const cellPhoneCommonValidators = (countries: ILoyaltyAppCountryAssignmentModel[], countryPrefixField: string = 'countryPrefix'): Array<ValidatorFn> => ([
    Validators.required,
    cellPhoneValidator,
    cellPhoneCountryValidator(countryPrefixField, countries),
]);
